import { Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import LoginPage from "./pages/Auth/LoginPage";
import ResetPasswordPage from "./pages/Auth/ResetPasswordPage";
import UserRoot from "./pages/User/UserRoot";
import Attendance from "./pages/Attendance";
import CheckCodePage from "./pages/Auth/CheckCodePage";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import ChangeDirectRoute from "./lib/ChangeDirectRoute";
import { useAuth } from "./context/AuthContext";
import Users from "./pages/Users";
import { UserProfile } from "./pages/UserProfile";
import EditUser from "./pages/EditUser";
import Categories from "./pages/Categories";
import AddUser from "./pages/AddUser";
import Projects from "./pages/Projects";
import AddProject from "./pages/AddProject";
import EditProject from "./pages/EditProject";
import Tasks from "./pages/TasksPages/Tasks";
import Teams from "./pages/TeamsPages/Teams";
import TeamTasks from "./pages/TeamsPages/TeamTasks";
import AddTasks from "./pages/TasksPages/AddTasks";
import EditTask from "./pages/TasksPages/EditTask";
import Loader from "./components/Common/LoaderPage";
import Salary from "./pages/Salary/Salary";
import Transaction from "./pages/Transaction/Transaction";
import { ConfigProvider, theme } from "antd";
import { useTheme } from "next-themes";

function App() {
  const { token, loading, user } = useAuth();

  const { theme: currentTheme, systemTheme } = useTheme();
  const isDarkMode =
    currentTheme === "dark" ||
    (currentTheme === "system" && systemTheme === "dark");

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen">
        <img
          src="/Artboard.png"
          alt="Logo"
          loading="lazy"
          className="object-contain animate-pulse w-1/3 h-1/3 "
        />
      </div>
    );

  return (
    <>
      <ConfigProvider
        theme={{
          algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
          token: {
            colorPrimary: "#2563eb",
            borderRadius: 8,
            colorBgContainer: "hsl(var(--background))",
            colorText: "hsl(var(--primary))",
            colorBgElevated: "hsl(var(--background))",
            colorBorder: "hsl(var(--border))",
          },
        }}
      >
        <Routes>
          <Route element={<ChangeDirectRoute auth={!!!token} to="/" />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/check-code" element={<CheckCodePage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Route>

          <Route element={<ChangeDirectRoute auth={!!token} to="/login" />}>
            <Route element={<UserRoot />}>
              {/* Admin */}
              <Route
                element={
                  <ChangeDirectRoute
                    auth={!loading && user?.role === "admin"}
                    to="/"
                  />
                }
              >
                <Route path="/users" element={<Users />} />
                <Route path="/users-add-profile" element={<AddUser />} />
                <Route path="/users-edit-profile/:bid" element={<EditUser />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/team-tasks/:id" element={<TeamTasks />} />
                <Route path="/salaries" element={<Salary />} />
                <Route path="/transactions" element={<Transaction />} />
              </Route>

              <Route path="/" element={<Attendance />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects-add" element={<AddProject />} />
              <Route path="/projects-edit/:bid" element={<EditProject />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/tasks-add" element={<AddTasks />} />
              <Route path="/tasks-edit/:bid" element={<EditTask />} />
              <Route path="/users-profile/:bid" element={<UserProfile />} />
            </Route>
          </Route>
        </Routes>
        <Toaster />
      </ConfigProvider>
    </>
  );
}

export default App;
